module.exports = __webpack_public_path__ + "static/img/p0.5e10b61b.png";